@if (visible()) {
  <!-- Backdrop -->
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
    <!-- Modal -->
    <div class="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl md:p-8"
         (click)="$event.stopPropagation()">

      <!-- Icon -->
      <div class="icon-circle mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             class="icon-phone"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      </div>

      <!-- Title -->
      <h2 class="mb-2 text-center text-xl font-bold text-gray-900">
        Precisamos do seu telefone
      </h2>

      <!-- Description -->
      <p class="mb-6 text-center text-sm text-gray-500">
        Para completar seu cadastro, informe um telefone de contato. Esse dado é obrigatório para sua segurança.
      </p>

      <!-- Form -->
      <form (submit)="$event.preventDefault()" class="flex flex-col gap-4">
        <div>
          <label for="phone-required" class="mb-1 block text-sm font-medium text-gray-700">
            Telefone
          </label>
          <input
            id="phone-required"
            type="tel"
            inputmode="numeric"
            [formControl]="phoneControl"
            appMask="(99) 99999-9999"
            placeholder="(00) 00000-0000"
            class="input-phone block w-full rounded-lg border px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 transition-colors"
            [ngClass]="{
              'border-gray-300': !phoneControl.touched || phoneControl.valid,
              'border-red-400 focus:border-red-500 focus:ring-red-500/20': phoneControl.touched && phoneControl.invalid
            }"
            [disabled]="loading()"
            autocomplete="tel"
          />
          @if (phoneControl.touched && phoneControl.invalid) {
            <p class="mt-1.5 text-xs text-red-500">
              @if (phoneControl.hasError('required')) {
                Informe seu telefone para continuar.
              } @else {
                Informe um telefone válido com DDD.
              }
            </p>
          }
        </div>

        <!-- Error message -->
        @if (errorMessage()) {
          <div class="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">
            {{ errorMessage() }}
          </div>
        }

        <!-- Submit button -->
        <button
          type="button"
          (click)="onSubmit()"
          [disabled]="phoneControl.invalid || loading()"
          class="btn-phone-submit mt-2 w-full rounded-lg px-4 py-3 text-sm font-semibold text-white transition-all focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50">
          @if (loading()) {
            <span class="flex items-center justify-center gap-2">
              <svg class="h-4 w-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Salvando...
            </span>
          } @else {
            Continuar
          }
        </button>
      </form>
    </div>
  </div>
}
